<template>
  <div id="app">
    <index></index>
    <router-view/>
    <footerView></footerView>
  </div>
</template>

<script>
import index from "./views/index/index.vue";
import footerView from "./components/footer.vue"
export default {
  name: 'App',
  components: {
    index,
    footerView
  }
}
</script>

<style scoped>
  #app {
    padding-top: 72px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue